import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import "../tps.css";

const Home = () => {
  const PlatformID = localStorage.getItem("platformID");
  const [totalAuthor, setTotalAuthor] = useState(0);
  const [totalReviewer, setTotalReviewer] = useState(0);
  const [totalPaper, setTotalPaper] = useState(0);
  const [totalPending, setTotalPending] = useState(0);
  const [acceptedPaper, setAcceptedPaper] = useState(0);
  const [pendingPaper, setPendingPaper] = useState(0);

  const [abstractCount, setAbstractCount] = useState(0);
  const [abstractAccepted, setAbstractAccepted] = useState(0);
  const [abstractPending, setAbstractPending] = useState(0);
  const [abstractRejected, setAbstractRejected] = useState(0);

  const [fullPaperCount, setFullPaperCount] = useState(0);
  const [fullAccepted, setFullAccepted] = useState(0);
  const [fullPending, setFullPending] = useState(0);
  const [fullRejected, setFullRejected] = useState(0);

  const [revisionCount, setRevisionCount] = useState(0);
  const [revisionAccepted, setRevisionAccepted] = useState(0);
  const [revisionPending, setRevisionPending] = useState(0);
  const [revisionRejected, setRevisionRejected] = useState(0);

  // NEW states for author and reviewer statuses
  const [totalAuthors, setTotalAuthors] = useState(0);
  const [approvedAuthors, setApprovedAuthors] = useState(0);
  const [notApprovedAuthors, setNotApprovedAuthors] = useState(0);
  const [pendingAuthors, setPendingAuthors] = useState(0);
  const [rejectedAuthors, setRejectedAuthors] = useState(0);

  const [totalReviewers, setTotalReviewers] = useState(0);
  const [approvedReviewers, setApprovedReviewers] = useState(0);
  const [notApprovedReviewers, setNotApprovedReviewers] = useState(0);

  const [pendingReviewers, setPendingReviewers] = useState(0);
  const [rejectedReviewers, setRejectedReviewers] = useState(0);

  const[holdCount, setHoldCount] = useState(0);
  const [scheduledCount , setScheduledCount] = useState(0);

  const API = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API}/api/host/auth-rev-paper/${PlatformID}`);
        const d = res.data;

        setTotalAuthor(d.authorCount ?? 0);
        setTotalReviewer(d.reviewerCount ?? 0);
        setTotalPaper(d.paperCount ?? 0);
        setTotalPending();
        setAcceptedPaper((d.fullAccepted ?? 0) + (d.revisionAccepted ?? 0));

        setPendingPaper(d.pendingPaper ?? 0);

        setAbstractCount(d.abstractCount ?? 0);
        setAbstractAccepted(d.abstractAccepted ?? 0);
        setAbstractPending(d.abstractPending ?? 0);
        setAbstractRejected(d.abstractRejected ?? 0);

        setFullPaperCount(d.fullPaperCount ?? 0);
        setFullAccepted(d.fullAccepted ?? 0);
        setFullPending(d.fullPending ?? 0);
        setFullRejected(d.fullRejected ?? 0);

        setRevisionCount(d.revisionCount ?? 0);
        setRevisionAccepted(d.revisionAccepted ?? 0);
        setRevisionPending(d.revisionPending ?? 0);
        setRevisionRejected(d.revisionRejected ?? 0);

                setHoldCount(d.holdCount ?? 0);
        setScheduledCount(d.scheduledCount ?? 0);


        // Set author status counts
        setTotalAuthors(d.totalAuthors ?? 0);
        setApprovedAuthors(d.approvedAuthors ?? 0);
        setNotApprovedAuthors(d.notapprovedAuthors ?? 0);
        setPendingAuthors(d.pendingAuthors ?? 0);
        setRejectedAuthors(d.rejectedAuthors ?? 0);

        // Set reviewer status counts
        setTotalReviewers(d.totalReviewers ?? 0);
        setApprovedReviewers(d.approvedReviewers ?? 0);
        setNotApprovedReviewers(d.notapprovedReviewers ?? 0);
        setPendingReviewers(d.pendingReviewers ?? 0);
        setRejectedReviewers(d.rejectedReviewers ?? 0);
      } catch (err) {
        console.error('Error fetching dashboard data:', err);
      }
    };

    if (PlatformID) {
      fetchData();
    }
  }, [API, PlatformID]);

  return (
    <div>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-16">
              <h1 className="m-0 page-title">Dashboard</h1>
              <hr />
              <h3 className='text-center'>Submissions Details</h3>
              <hr />
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            {/* Total Approved Authors */}
            {/* <div className="col-lg-3 col-6">
              <Link to="/host/authors-list" state={{ defaultFilter: 'approved' }} className="text-decoration-none">
                <div className="small-box bg-info">
                  <div className="inner">
                    <h3>{totalAuthor}</h3>
                    <p>Total Approved Authors</p>
                  </div>
                </div>
              </Link>
            </div> */}

            {/* Total Approved Reviewers */}


            {/* Total Papers */}
            <div className="col-lg-3 col-6">
              <Link to="/host/submission-list" state={{ defaultStatusFilter: 'all' }} className="text-decoration-none">
                <div className="small-box bg-secondary">
                  <div className="inner">
                    <h3>{totalPaper}</h3>
                    <p>Total Paper Submissions</p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-lg-3 col-6 ">
              <Link to="/host/submission-assignment" className="text-decoration-none">
                <div className="small-box " style={{ height: "113px", backgroundColor: '#baeb34' }}>
                  <div className="inner">
                    <h3>{totalPending}</h3>
                    <p style={{ color: 'black' }}>Assign Pending Submissions</p>
                  </div>
                </div>
              </Link>
            </div>

            {/* Final Accepted Papers */}
            <div className="col-lg-3 col-6">
              <Link to="/host/submission-list" state={{ defaultStatusFilter: 'accept' }} className="text-decoration-none">
                <div className="small-box bg-info">
                  <div className="inner">
                    <h3>{acceptedPaper}</h3>
                    <p>Final Accepted Submissions</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div className="row mt-4">
            <h4>Abstracts</h4>
            <div className="col-lg-3 col-6">
              <Link to="/host/submission-list" state={{ defaultStatusFilter: 'all', defaultTypeFilter: 'abstract' }} className="text-decoration-none">
                <div className="small-box bg-primary fixed-box">
                  <div className="inner">
                    <h3>{abstractCount}</h3>
                    <p>All Submissions</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-3 col-6">
              <Link to="/host/review-replies-list" state={{ filterStatus: 'Pending', filterType: 'Abstract' }} className="text-decoration-none">
                <div className="small-box bg-warning fixed-box">
                  <div className="inner">
                    <h3>{abstractPending}</h3>
                    <p>Pending Submissions reviews</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-3 col-6">
              <Link to="/host/submission-list" state={{ defaultStatusFilter: 'accept', defaultTypeFilter: 'abstract' }} className="text-decoration-none">
                <div className="small-box bg-success fixed-box">
                  <div className="inner">
                    <h3>{abstractAccepted}</h3>
                    <p>Accepted Submissions</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-3 col-6">
              <Link to="/host/submission-list" state={{ defaultStatusFilter: 'reject', defaultTypeFilter: 'abstract' }} className="text-decoration-none">
                <div className="small-box bg-danger fixed-box">
                  <div className="inner">
                    <h3>{abstractRejected}</h3>
                    <p>Rejected Submissions</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div className="row mt-4">
            <h4>Full Papers</h4>
            <div className="col-lg-3 col-6">
              <Link to="/host/submission-list" state={{ defaultStatusFilter: 'all', defaultTypeFilter: 'full' }} className="text-decoration-none">
                <div className="small-box bg-primary fixed-box">
                  <div className="inner">
                    <h3>{fullPaperCount}</h3>
                    <p>All Submissions</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-3 col-6">
              <Link to="/host/review-replies-list" state={{ filterStatus: 'Pending', filterType: 'Full_Paper' }} className="text-decoration-none">
                <div className="small-box bg-warning fixed-box">
                  <div className="inner">
                    <h3>{fullPending}</h3>
                    <p>Pending Submissions reviews</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-3 col-6">
              <Link to="/host/submission-list" state={{ defaultStatusFilter: 'accept', defaultTypeFilter: 'full' }} className="text-decoration-none">
                <div className="small-box bg-success fixed-box">
                  <div className="inner">
                    <h3>{fullAccepted}</h3>
                    <p>Accepted Submissions</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-3 col-6">
              <Link to="/host/submission-list" state={{ defaultStatusFilter: 'reject', defaultTypeFilter: 'full' }} className="text-decoration-none">
                <div className="small-box bg-danger fixed-box">
                  <div className="inner">
                    <h3>{fullRejected}</h3>
                    <p>Rejected Submissions</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div className="row mt-4">
            <h4>Revisions</h4>
            <div className="col-lg-3 col-6">
              <Link to="/host/submission-list" state={{ defaultStatusFilter: 'all', defaultTypeFilter: 'revision' }} className="text-decoration-none">
                <div className="small-box bg-primary fixed-box">
                  <div className="inner">
                    <h3>{revisionCount}</h3>
                    <p>All Submissions</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-3 col-6">
              <Link to="/host/review-replies-list" state={{ filterStatus: 'Pending', filterType: 'Revision' }} className="text-decoration-none">
                <div className="small-box bg-warning fixed-box">
                  <div className="inner">
                    <h3>{revisionPending}</h3>
                    <p>Pending Submissions reviews</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-3 col-6">
              <Link to="/host/submission-list" state={{ defaultStatusFilter: 'accept', defaultTypeFilter: 'revision' }} className="text-decoration-none">
                <div className="small-box bg-success fixed-box">
                  <div className="inner">
                    <h3>{revisionAccepted}</h3>
                    <p>Accepted Submissions</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-3 col-6">
              <Link to="/host/submission-list" state={{ defaultStatusFilter: 'reject', defaultTypeFilter: 'revision' }} className="text-decoration-none">
                <div className="small-box bg-danger fixed-box">
                  <div className="inner">
                    <h3>{revisionRejected}</h3>
                    <p>Rejected Submissions</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>


           <div className="row mt-4">
              <hr />
            <h3 className='text-center'>Accepted paper Details</h3>
            <hr />
            <div className="col-lg-3 col-6">
              <Link to="/host/submission-list" state={{ defaultStatusFilter: 'accept', defaultTypeFilter: 'all', defaultScheduleFilter: 'scheduled' }} className="text-decoration-none">
                <div className="small-box bg-success fixed-box">
                  <div className="inner">
                    <h3>{scheduledCount}</h3>
                    <p>Scheduled Submissions</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-3 col-6">
              <Link to="/host/submission-list" state={{ defaultStatusFilter: 'accept', defaultTypeFilter: 'all', defaultScheduleFilter: 'hold' }} className="text-decoration-none">
                <div className="small-box bg-warning fixed-box">
                  <div className="inner">
                    <h3>{holdCount}</h3>
                    <p>Hold Submissions</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>


          {/* ======== Authors Section ======== */}
          <div className="row mt-5">
            <hr />
            <h3 className='text-center'>Author & Reviewer Details</h3>
            <hr />
            <h4>Authors</h4>


            <div className="col-lg-2 col-3">
              <Link to="/host/authors-list" state={{ defaultFilter: 'all' }} className="text-decoration-none">
                <div className="small-box bg-primary fixed-box">
                  <div className="inner">
                    <h3>{totalAuthors}</h3>
                    <p>Total Authors</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-2 col-3">
              <Link to="/host/authors-list" state={{ defaultFilter: 'approved' }} className="text-decoration-none">
                <div className="small-box bg-secondary">
                  <div className="inner">
                    <h3>{approvedAuthors}</h3>
                    <p>Approved Authors</p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-lg-2 col-3">
              <Link to="/host/verify-author" className="text-decoration-none">
                <div className="small-box bg-info">
                  <div className="inner">
                    <h3>{notApprovedAuthors}</h3>
                    <p>NotApproved Authors</p>
                  </div>
                </div>
              </Link>
            </div>


            <div className="col-lg-2 col-3">
              <Link to="/host/authors-list" state={{ defaultFilter: 'pending' }} className="text-decoration-none">
                <div className="small-box bg-warning">
                  <div className="inner">
                    <h3>{pendingAuthors}</h3>
                    <p>Pending Authors</p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-lg-2 col-3">
              <Link to="/host/authors-list" state={{ defaultFilter: 'rejected' }} className="text-decoration-none">
                <div className="small-box bg-danger">
                  <div className="inner">
                    <h3>{rejectedAuthors}</h3>
                    <p>Rejected Authors</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          {/* ======== Reviewers Section ======== */}
          <div className="row mt-5">
            <h4>Reviewers</h4>

            <div className="col-lg-2 col-3">
              <Link to="/host/reviewer-list" state={{ defaultFilter: 'all' }} className="text-decoration-none">
                <div className="small-box bg-primary fixed-box">
                  <div className="inner">
                    <h3>{totalReviewers}</h3>
                    <p>Total Reviewers</p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-lg-2 col-3">
              <Link to="/host/reviewer-list" state={{ defaultFilter: 'approved' }} className="text-decoration-none">
                <div className="small-box bg-secondary">
                  <div className="inner">
                    <h3>{approvedReviewers}</h3>
                    <p>Approved Reviewers</p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-lg-2 col-3">
              <Link to="/host/verify-reviewer" className="text-decoration-none">
                <div className="small-box bg-success">
                  <div className="inner">
                    <h3>{notApprovedReviewers}</h3>
                    <p>NotApproved Reviewers</p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-lg-2 col-3">
              <Link to="/host/reviewer-list" state={{ defaultFilter: 'pending' }} className="text-decoration-none">
                <div className="small-box bg-warning">
                  <div className="inner">
                    <h3>{pendingReviewers}</h3>
                    <p>Pending Reviewers</p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-lg-2 col-3">
              <Link to="/host/reviewer-list" state={{ defaultFilter: 'rejected' }} className="text-decoration-none">
                <div className="small-box bg-danger">
                  <div className="inner">
                    <h3>{rejectedReviewers}</h3>
                    <p>Rejected Reviewers</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
